import React from 'react';

import PracticQuestionSubjects from '../subjects/PracticQuestionSubjects';

function PreviousQuestions() {


  return (

    <>
      

      <PracticQuestionSubjects 
        name=" Previous 12 Years Questions (PYQs)" 
        link="previous-year-questions" 
        type="previousyearquestions" 
      />

    </>
  );
}

export default PreviousQuestions;